module.exports = __webpack_public_path__ + "fonts/SFUIText-Medium.436a59e6.woff";